let base_url_sign = '/sign';
let base_url_pages = '';
const LYCMarketConsoleBase = "/lyc_lingyun";
const lyc_user_url = "/lyc_user";


let main_routes_all = {
    pages: {
        default: base_url_pages + '/',
        home: base_url_pages + '/home',
        homeUpdate: base_url_pages + '/homeUpdate',
        commodityTemplate: base_url_pages + '/commodityTemplate',
        lightMedia: base_url_pages + '/lightMedia',
        integrationMedia: base_url_pages + '/integrationMedia',
        provincePlatform: base_url_pages + '/provincePlatform',
        news: base_url_pages + '/news',
        operation: base_url_pages + '/operation',
        cases: base_url_pages + '/cases',
        noticeInfo: base_url_pages + '/noticeInfo',
        contactUs: base_url_pages + '/contactUs',
    },
    sign: {
        signUp: base_url_sign + '/signUp',
        signIn: base_url_sign + '/signIn',
        forgetPWD: base_url_sign + '/forgetPWD',
        SignUpHome: base_url_sign + '/signUpHome',
    },
    lyc_user: {
        balanceManage: LYCMarketConsoleBase + lyc_user_url + "/balanceManage",
        myServiceRenew: LYCMarketConsoleBase + lyc_user_url + "/myServiceRenew",
    }
};

export default main_routes_all;



// WEBPACK FOOTER //
// ./src/router/main_routes_all.js